<template>
  <span @click="copyWord" ref="slotRef" style="cursor: pointer"
    ><slot></slot
  ></span>
</template>

<script>
export default {
  name: "wordCopy",

  methods: {
    copyWord() {
      let text = this.$refs.slotRef.innerText.trim();

      if (navigator.clipboard) {
        // clipboard api 复制
        navigator.clipboard.writeText(text);
      } else {
        var textarea = document.createElement("textarea");
        document.body.appendChild(textarea);
        // 隐藏此输入框
        textarea.style.position = "fixed";
        textarea.style.clip = "rect(0 0 0 0)";
        textarea.style.top = "10px";
        // 赋值
        textarea.value = text;
        // 选中
        textarea.select();
        // 复制
        document.execCommand("copy", true);
        // 移除输入框
        document.body.removeChild(textarea);
      }
      this.$message.info("名称已复制到剪切板中");
    },
  },
};
</script>
